import axios from 'axios';

export default {
  methods: {
    trackWatchlist() {
      axios.get('/dashboard/request-type?requestType=WATCHLIST');
    },
    trackCSVDownload() {
      axios.get('/dashboard/request-type?requestType=CSV_DOWNLOAD');
    },
    trackLucaAccess() {
      axios.get('/dashboard/request-type?requestType=LUCA_ACCESS');
    },
    trackLogin() {
      axios.get('/dashboard/request-type?requestType=LOGIN');
    }
  }
};
